module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-06-ae3f68e53980702bec72678a4eb0c053.jpg";